import { development } from './development';
import { production } from './production';

const env = process.env.NODE_ENV;

export const ENV = env === 'development' ? development : production;

/**
 * 用户角色权限
 */
export const ROLE_TYPE = [
  {
    label: '全部角色',
    value: ''
  },
  {
    label: '系统管理员',
    value: 1
  },
  {
    label: '数据维护员',
    value: 2
  }
  // {
  //   label: 'GIS查询员',
  //   value: 3
  // },
  // {
  //   label: '建筑巡查员',
  //   value: 4
  // }
];

/**
 * 区域
 */
export const AREA = [
  {
    label: '全部区域',
    value: ''
  },
  {
    label: '城厢街道',
    value: 'CHENGXIANGJIEDAO'
  },
  {
    label: '北干街道',
    value: 'NBEIGANJIEDAO'
  },
  {
    label: '蜀山街道',
    value: 'NSHUSHANJIEDAO'
  },
  {
    label: '新塘街道',
    value: 'XINTANGJIEDAO'
  },
  {
    label: '南阳街道',
    value: 'NANYANGJIEDAO'
  },
  {
    label: '靖江街道',
    value: 'JINGJIANGJIEDAO'
  },
  {
    label: '闻堰街道',
    value: 'WENYANJIEDAO'
  },
  {
    label: '宁围街道',
    value: 'NINGWEIJIEDAO'
  },
  {
    label: '新街街道',
    value: 'XINJIEJIEDAO'
  },
  {
    label: '盈丰街道',
    value: 'YINGFENGJIEDAO'
  },
  {
    label: '河上镇',
    value: 'HESHANGZHEN'
  },
  {
    label: '戴村镇',
    value: 'DAICUNZHEN'
  },
  {
    label: '浦阳镇',
    value: 'PUYANGZHEN'
  },
  {
    label: '进化镇',
    value: 'JINHUAZHEN'
  },
  {
    label: '临浦镇',
    value: 'LINPUZHEN'
  },
  {
    label: '楼塔镇',
    value: 'LOUTAZHEN'
  },
  {
    label: '义桥镇',
    value: 'YIQIAOZHEN'
  },
  {
    label: '所前镇',
    value: 'SUOQIANZHEN'
  },
  {
    label: '衙前镇',
    value: 'YAQIANZHEN'
  },
  {
    label: '瓜沥镇',
    value: 'GUALIZHEN'
  },
  {
    label: '益农镇',
    value: 'YINONGZHEN'
  },
  {
    label: '党湾镇',
    value: 'DANGWANZHEN'
  }
];
//保护级别
export const PROTECT_LEVEL = [
  {
    label: '全部级别',
    value: ''
  },
  {
    label: '一类历史建筑',
    value: 'GUOBAO'
  },
  {
    label: '二类历史建筑',
    value: 'SHENGBAO'
  },
  {
    label: '三类历史建筑',
    value: 'SHIXIANBAO'
  },
  {
    label: '农村历史建筑',
    value: 'WEIHEDING'
  }
];
//建筑类别
export const RELIC_TYPE = [
  {
    label: '全部类别',
    value: ''
  },
  {
    label: '居住建筑',
    value: 'GUYIZHI'
  },
  {
    label: '公共建筑',
    value: 'GUMUZANG'
  },
  {
    label: '工业建筑',
    value: 'GUJIANZHU'
  },
  {
    label: '构建物',
    value: 'SHIKUSIJISHIKE'
  }
  // {
  //   label: '近现代建筑',
  //   value: 'JINXIANDAIJIANZHU'
  // },
  // {
  //   label: '其他',
  //   value: 'QITA'
  // }
];

//巡查状态
export const STATUS = [
  {
    label: '全部状态',
    value: ''
  },
  {
    label: '正常',
    value: 'NORMAL'
  },
  {
    label: '异常',
    value: 'ABNORMAL'
  },
  {
    label: '未巡查',
    value: 'WEIXUNCHA'
  }
];

export const SELECT_AREA = [
  {
    label: '城厢街道',
    value: 'CHENGXIANGJIEDAO'
  },
  {
    label: '北干街道',
    value: 'NBEIGANJIEDAO'
  },
  {
    label: '蜀山街道',
    value: 'NSHUSHANJIEDAO'
  },
  {
    label: '新塘街道',
    value: 'XINTANGJIEDAO'
  },
  {
    label: '南阳街道',
    value: 'NANYANGJIEDAO'
  },
  {
    label: '靖江街道',
    value: 'JINGJIANGJIEDAO'
  },
  {
    label: '闻堰街道',
    value: 'WENYANJIEDAO'
  },
  {
    label: '宁围街道',
    value: 'NINGWEIJIEDAO'
  },
  {
    label: '新街街道',
    value: 'XINJIEJIEDAO'
  },
  {
    label: '盈丰街道',
    value: 'YINGFENGJIEDAO'
  },
  {
    label: '河上镇',
    value: 'HESHANGZHEN'
  },
  {
    label: '戴村镇',
    value: 'DAICUNZHEN'
  },
  {
    label: '浦阳镇',
    value: 'PUYANGZHEN'
  },
  {
    label: '进化镇',
    value: 'JINHUAZHEN'
  },
  {
    label: '临浦镇',
    value: 'LINPUZHEN'
  },
  {
    label: '楼塔镇',
    value: 'LOUTAZHEN'
  },
  {
    label: '义桥镇',
    value: 'YIQIAOZHEN'
  },
  {
    label: '所前镇',
    value: 'SUOQIANZHEN'
  },
  {
    label: '衙前镇',
    value: 'YAQIANZHEN'
  },
  {
    label: '瓜沥镇',
    value: 'GUALIZHEN'
  },
  {
    label: '益农镇',
    value: 'YINONGZHEN'
  },
  {
    label: '党湾镇',
    value: 'DANGWANZHEN'
  }
];
export const SELECT_LEVEL = [
  {
    label: '一类历史建筑',
    value: 'GUOBAO'
  },
  {
    label: '二类历史建筑',
    value: 'SHENGBAO'
  },
  {
    label: '三类历史建筑',
    value: 'SHIXIANBAO'
  },
  {
    label: '农村历史建筑',
    value: 'WEIHEDING'
  }
];
export const SELECT_TYPE = [
  {
    label: '居住建筑',
    value: 'GUYIZHI'
  },
  {
    label: '公共建筑',
    value: 'GUMUZANG'
  },
  {
    label: '工业建筑',
    value: 'GUJIANZHU'
  },
  {
    label: '构建物',
    value: 'SHIKUSIJISHIKE'
  }
  // {
  //   label: '近现代建筑',
  //   value: 'JINXIANDAIJIANZHU'
  // },
  // {
  //   label: '其他',
  //   value: 'QITA'
  // }
];

export const AREA_MAP = new Map([
  ['CHENGXIANGJIEDAO', '城厢街道'],
  ['NBEIGANJIEDAO', '北干街道'],
  ['NSHUSHANJIEDAO', '蜀山街道'],
  ['XINTANGJIEDAO', '新塘街道'],
  ['NANYANGJIEDAO', '南阳街道'],
  ['JINGJIANGJIEDAO', '靖江街道'],
  ['WENYANJIEDAO', '闻堰街道'],
  ['NINGWEIJIEDAO', '宁围街道'],
  ['XINJIEJIEDAO', '新街街道'],
  ['YINGFENGJIEDAO', '盈丰街道'],
  ['HESHANGZHEN', '河上镇'],
  ['DAICUNZHEN', '戴村镇'],
  ['PUYANGZHEN', '浦阳镇'],
  ['JINHUAZHEN', '进化镇'],
  ['LINPUZHEN', '临浦镇'],
  ['LOUTAZHEN', '楼塔镇'],
  ['YIQIAOZHEN', '义桥镇'],
  ['SUOQIANZHEN', '所前镇'],
  ['YAQIANZHEN', '衙前镇'],
  ['GUALIZHEN', '瓜沥镇'],
  ['YINONGZHEN', '益农镇'],
  ['DANGWANZHEN', '党湾镇']
]);

export const LEVEL_MAP = new Map([
  ['GUOBAO', '一类历史建筑'],
  ['SHENGBAO', '二类历史建筑'],
  ['SHIXIANBAO', '三类历史建筑'],
  ['WEIHEDING', '农村历史建筑']
]);

export const STATUS_MAP = new Map([
  ['NORMAL', '正常'],
  ['ABNORMAL', '异常'],
  ['WEIXUNCHA', '未巡查']
]);

export const TYPE_MAP = new Map([
  ['GUYIZHI', '居住建筑'],
  ['GUMUZANG', '公共建筑'],
  ['GUJIANZHU', '工业建筑'],
  ['SHIKUSIJISHIKE', '构建物']
  // ['JINXIANDAIJIANZHU', '近现代建筑'],
  // ['QITA', '其他']
]);

export const REPORT_TYPE = [
  {
    label: '全部类型',
    value: ''
  },
  {
    label: '日常',
    value: 'RICHAI'
  },
  {
    label: '定期',
    value: 'DINGQI'
  },
  {
    label: '专项',
    value: 'ZHUANXIANG'
  }
];

export const REPORT_STATUS = [
  {
    label: '全部状态',
    value: ''
  },
  {
    label: '正常',
    value: 'NORMAL'
  },
  {
    label: '异常',
    value: 'ABNORMAL'
  },
  {
    label: '未巡查',
    value: 'WEIXUNCHA'
  }
];

export const REPORT_TYPE_MAP = new Map([
  ['DINGQI', '定期'],
  ['RICHAI', '日常'],
  ['ZHUANXIANG', '专项']
]);

export const REPORT_STATUS_MAP = new Map([
  ['NORMAL', '正常'],
  ['ABNORMAL', '异常'],
  ['WEIXUNCHA', '未巡查']
]);

export function transformMap(data) {
  const test = new Map();
  for (let [key, value] of data) {
    test.set(value, key);
  }
  return test;
}
